export default "__VITE_ASSET__Bsu3ozOE__"